import { themes } from 'kb-shared';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: 20px;
  padding-right: 20px;

  @media screen and ${themes.queries.minDesktop} {
    margin-top: 24px;
  }
`;

export const TitleText = styled.span`
  font-size: 28px;
  color: ${themes.colors.neutral.primaryNavy};

  @media screen and ${themes.queries.minDesktop} {
    font-size: 36px;
  }
`;

export const SubtitleText = styled.span`
  font-size: 16px;
  color: ${themes.colors.neutral.primaryNavy};
  white-space: pre-wrap;
`;

export const QuestionsContainer = styled.div`
  padding-top: 28px;
`;

export const OptionContainer = styled.div`
  margin: 18px 0px;
`;
